import React from "react";
import UserUpdateLayerCustom from "../components/UserUpdateLayerCustom";
import MasterLayout from "../masterLayout/MasterLayout";
import { useParams } from "react-router-dom"; // Import useParams

const UserUpdatePage = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <>
      <MasterLayout>
      {/* SignUpLayer */}
      <UserUpdateLayerCustom userId={id} />
      </MasterLayout>
    </>
  );
};

export default UserUpdatePage; 
